export default __webpack_public_path__ + "static/media/remove-symbol.f3d982ed.svg";